import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import React from 'react';
import classNames from 'classnames';
import { Messages } from 'primereact/messages';
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";

export const ChangePasswordPage = () => {

    const [token, setToken] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [submitted, setSubmitted]  = React.useState(false);
    
    const message = React.useRef();
    let history = useHistory();
    const location = useLocation();

    React.useEffect(function() {
        setToken(location.state.token);
    }, [location]);

    const showSuccess = (msg) => {
        message.current.show({ severity: 'success', content: msg, life: 3000 });
    };

    const showFailed = (msg) => {
        message.current.show({ severity: 'error', content: msg, life: 3000 });
    };

    const showError = (msg) => {
        message.current.show({ severity: 'error', content: msg, life: 3000 });
    };

    async function clickSubmit(event) {
        event.preventDefault();
        setSubmitted(true);

        if(!password || !confirmPassword || password !== confirmPassword) {         
            showError('confirm password tidak sama!')               
        } else {
            const requestPayload =  {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                },
                body: JSON.stringify({
                    password: password,
                    token: token
                })
            }
            
            const response = await fetch('https://springboot-widy-app.widyan123.site/widy-app/forgot-password/change-password', requestPayload);
            const res = await response.json();
            if(response.status >= 200 && response.status <= 299) {                
                showSuccess(res.message);
                setTimeout(() => {
                    history.push('/login');
                }, 5000)
            } else if(response.status >= 400 && response.status <= 499) {
                showFailed(res.message);
            } else {
                showError(res.message);
            }            
        }
    }

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Change Password</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                </div>
                <div className='card p-fluid'>
                    <Messages ref={message} />
                    <form onSubmit={clickSubmit}>
                        <div className="field">
                            <label htmlFor="password">Password</label>
                            <InputText id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={classNames({ 'p-invalid': submitted && !password })} />
                            {submitted && !password && <small className="p-error">Enter your password</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="confirmPassword">Confirm Password</label>
                            <InputText id="confirmPassword" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className={classNames({ 'p-invalid': submitted && !confirmPassword })} />
                            {submitted && !confirmPassword && <small className="p-error">Enter your Confirm Password</small>}
                        </div>
                        <Button label="Submit" className="p-button-success mr-2" />
                    </form>
                </div>  
            </div>
        </div>
    );
}
